import React, { useState, useEffect } from "react";
import Loadspinner from "../../common/Loadspinner";
import Main from "../../common/Main/Main";
import { Typography, TextField, Tooltip } from "@mui/material";
import InputForm from "../../ReusableComponents/InputForm/InputForm";
import FormLabel from "../../ReusableComponents/FormLabel/FormLabel";
import * as images from "../../constants/Images";
import SelectForm from "../../ReusableComponents/SelectForm/SelectForm";
import { useHistory, useLocation } from "react-router-dom";
import { APICall } from "../../helpers/API/APICalls";
import { Form } from "react-bootstrap";
import {
  conversionProgress,
  getCommonDropdownData,
  getHashtagsAutoComplete,
  getKnowledgeDataById,
  insertNewGeneratedHashtagsInMaster,
  updateKnowledgeDataById,
} from "../../helpers/API/APIEndPoints";
import notify from "../../ReusableComponents/ToastNotification/ToastNotification";
import { Modal } from "react-bootstrap";
import ViewHistory from "../../ReusableComponents/ViewHistory/ViewHistory";
import SelectFormCreatableV2 from "../../ReusableComponents/SelectForm/SelectFormCreatableV2";
import moment from "moment";
import CreateKnowledgeService from "../../services/CreateKnowledgeService";
import Decrypt from "../../services/Decryption";
import { Collapse, Paper } from "@mui/material";
import CommonConstants from "../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";
import VideoModal from "../../common/VideoModal/VideoModal";
import ConversionStatus from "../../helpers/Constants/ConversionStatus";
import FileExtensionAllowed from "../../helpers/FileExtensionAllowed.js/FileExtensionAllowed";

const queryString = () => new URLSearchParams(useLocation().search);

const DashboardEdit = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [id, setId] = useState(null);
  const [mode, setMode] = useState(null);

  let query = queryString();
  query = Object.fromEntries([...query]);

  const history = useHistory();
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [requestDetailData, setRequestDetailData] = useState({});
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [restrictedUsers, setRestrictedUsers] = useState([]);
  const [restrictedCoe, setRestrictedCoe] = useState([]);
  const [tagUsers, setTagUsers] = useState([]);
  const [hashtags, setHashtags] = useState([]);
  const [selectedhashtagArray, setSelectedHashtagsArray] = useState([]);
  const [userNameOptions, setUserNameOptions] = useState([]);
  const [defaultRestrictedUsers, setDefaultRestrictedUsers] = useState([]);
  const [defaultRestrictedCoe, setDefaultRestrictedCoe] = useState([]);
  const [defaultTagUsers, setDefaultTagUsers] = useState([]);
  const [defaultHastags, setDefaultHastags] = useState([]);
  const [hashtagOptions, setHashtagOptions] = useState([]);
  const [currentLocation, setCurrentLocation] = useState("");
  const [action, setAction] = useState("");
  const [actionModal, setActionModal] = useState(false);

  const [keywords, setKeywords] = useState("");
  const [remark, setRemark] = useState("");
  const [knowledgeBaseOptions, setKnowledgeBaseOptions] = useState([]);
  const [knowledgeBaseId, setKnowledgeBaseId] = useState(null);
  const [verificationStatus, setVerificationStatus] = useState("");

  const [attachment, setAttachment] = useState(null);
  const [fileName, setFilename] = useState("");
  const [fileConversionStatus, setFileConversionStatus] = useState(null);
  const [isFileConversionStatusSet, setIsFileConversionStatusSet] =
    useState(false);
  const [fileType, setFileType] = useState("");
  // const [videoId, setVideoId] = useState("");
  const [viewVideoId, setViewVideoId] = useState("");
  const [viewVideoUrl, setViewVideoUrl] = useState("");
  const [viewVideoMetadata, setViewVideoMetadata] = useState("");
  const [firstToken, setToken] = useState("");
  const [thumbnailId, setThumbnailId] = useState("");
  const [transcriptionData, setTranscriptionData] = useState("");
  const [progressStatus, setProgStatus] = useState(0);
  const [progress, setProgress] = useState();
  const [showVideoModal, setShowVideoModal] = useState(false);

  const [isAdmin, setIsAdmin] = useState(
    Decrypt(getFromEncLocalStorage("ggwp") || ""),
  );

  const [coeHideList, setCoeHideList] = useState([]);
  const [globalFDPD, setGlobalFDPD] = useState(false);
  const [globalFDPDClass, setGlobalFDPDClass] = useState(
    "row rowMargin disabledDiv",
  );

  const allowedExtensions = [
    "webm",
    "mp3",
    "ppt",
    "docx",
    "pdf",
    "xlsx",
    "jpg",
    "jpeg",
    "png",
    "mp4",
  ];

  const getCommonDropdownUserNameDataApiCall = async () => {
    setLoading(true);
    let requestParams = {
      dropdownName: "getAllUsersDropdown",
    };
    const res = await APICall(getCommonDropdownData, requestParams, "POST");

    if (res && res.data.length > 0) {
      let options = await res.data;
      // options = await options.map((ele) => ({
      //   label: ele.Name,
      //   value: ele.Id,
      // }));

      await setUserNameOptions(options);
      setLoading(false);
    } else {
      await setUserNameOptions([]);
      notify(1, res.message);
      setLoading(false);
    }
  };

  const getHastagDropdownDataApiCall = async () => {
    setLoading(true);
    let requestParams = {
      dropdownName: "hashtagDropdown",
    };
    const res = await APICall(getCommonDropdownData, requestParams, "POST");

    if (res && res.data.length > 0) {
      setHashtagOptions(res.data);
      setLoading(false);
    } else {
      setHashtagOptions([]);
      notify(1, res.message);
      setLoading(false);
    }
  };

  const checkVideoProcessingStatus = async (documentName) => {
    let requestParams = {
      documentId: documentName,
      fromDashboard: true,
    };
    const resp = await APICall(conversionProgress, requestParams);

    if (resp?.error === false) {
      return resp?.progress;
    }

    return false;
  };

  useEffect(() => {
    let interval = null;
    if (
      fileConversionStatus &&
      fileConversionStatus?.video_conversion_status &&
      fileConversionStatus?.video_conversion_status != ConversionStatus.UPLOADED
    ) {
      interval = setInterval(async () => {
        const progress = await checkVideoProcessingStatus(
          fileConversionStatus.document_name,
        );
        //console.log("🚀 ~ file: DashboardEdit.js:159 ~ interval=setInterval ~ progress:", progress);

        let progressData = Array.isArray(progress) ? progress?.[0] : progress;
        //console.log("🚀 ~ file: DashboardEdit.js:160 ~ interval=setInterval ~ progressData:", progressData);
        if (progressData) {
          if (progressData?.progress_int && progressData?.progress_int > -1) {
            setFileConversionStatus({
              ...fileConversionStatus,
              video_conversion_status: progressData?.status,
              progress_int: progressData?.progress_int,
            });
          }

          if (progressData?.progress_int >= 100) {
            //console.log("🚀 ~ file: DashboardEdit.js:171 ~ interval=setInterval ~ progressData: 100%");
            clearInterval(interval);
            setFileConversionStatus({
              ...fileConversionStatus,
              video_conversion_status: progressData?.status,
              progress_int: 100,
              progress: 100,
            });
          }
        }
      }, 5000);
    }

    if (interval) {
      return () => {
        console.log("🚀 ~ file: DashboardEdit.js:188 ~ return ~ Cleaning up:");
        clearInterval(interval);
      };
    }
  }, [fileConversionStatus]);

  useEffect(() => {
    let id, mode;
    if (
      (id === undefined || id === null) &&
      (mode === undefined || mode === null)
    ) {
      setId(location?.state?.id || query.id);
      id = location?.state?.id || query.id;
      setMode(location?.state?.mode || query.mode);
      mode = location?.state?.mode || query.mode;
    }

    if (id !== undefined || id !== null) {
      getRequestData(id);
    } else {
      notify(1, "Request Data not found");
      history.goBack();
    }
  }, []);

  const getRequestData = async (id) => {
    const res = await APICall(getKnowledgeDataById, { id });
    if (res.data !== null) {
      let data = res.data[0];
      console.log(
        "🚀 ~ file: DashboardEdit.js:157 ~ getRequestData ~ data:",
        data,
      );
      setRequestDetailData(data);
      setTitle(data.title);
      setDescription(data.description);
      setAttachment(data.attachment);
      setFilename(data.attachment_file_name);
      setFileType(data.attachment_file_type);
      setFileConversionStatus({
        document_name: data?.document_name,
        type: data?.type,
        video_conversion_status: data?.video_conversion_status,
        progress: data?.progress,
        progress_int: data?.progress_int,
        failure_count: data?.failure_count,
      });
      setIsFileConversionStatusSet(true);
      setKeywords(data.Keywords);
      setCurrentLocation(data.Location);
      setViewVideoId(data?.video_id);
      setViewVideoUrl(data?.VideoUrl);
      setViewVideoMetadata(data?.VideoMetadata);
      await getCommonDropdownUserNameDataApiCall();
      await getHastagDropdownDataApiCall();
    } else {
      notify(1, "Request Data not found");
      history.goBack();
    }
  };

  console.log("viewVideoMetadata", viewVideoMetadata);

  useEffect(() => {
    if (userNameOptions.length > 0) {
      if (requestDetailData.TaggedUserIds) {
        let taggedUsersArr = requestDetailData.TaggedUserIds.split(",");

        let tempOption = [];
        taggedUsersArr.forEach((element) => {
          let temp = userNameOptions.find((ele) => ele.value == element);
          tempOption.push(temp);
        });

        setTagUsers(tempOption);
        setDefaultTagUsers(tempOption);
      }

      if (
        !requestDetailData.RestrictedUserIds &&
        !requestDetailData.RestrictedCOEIds
      ) {
        setGlobalFDPD(true);
      } else {
        setGlobalFDPD(false);
      }

      if (requestDetailData.RestrictedUserIds) {
        let taggedUsersArr = requestDetailData.RestrictedUserIds.split(",");

        let tempOption = [];
        taggedUsersArr.forEach((element) => {
          let temp = userNameOptions.find((ele) => ele.value == element);
          tempOption.push(temp);
        });

        setRestrictedUsers(tempOption);
        setDefaultRestrictedUsers(tempOption);
      }

      if (requestDetailData.RestrictedCOEIds) {
        let taggedUsersArr = requestDetailData.RestrictedCOEIds.split(",");

        let tempOption = [];
        taggedUsersArr.forEach((element) => {
          let temp = userNameOptions.find((ele) => ele.value == element);
          tempOption.push(temp);
        });

        setRestrictedCoe(tempOption);
        setDefaultRestrictedCoe(tempOption);
      }
    }
  }, [userNameOptions]);

  useEffect(() => {
    if (
      hashtagOptions.length > 0 &&
      requestDetailData.HashtagIds !== null &&
      requestDetailData.HashtagIds != "" &&
      requestDetailData.HashtagIds != undefined &&
      requestDetailData.HashtagIds
    ) {
      let hastagArr = requestDetailData.HashtagIds.split(",");

      let tempOption = [];
      hastagArr.forEach((element) => {
        let temp = hashtagOptions.find((ele) => ele.value == element);
        tempOption.push(temp);
      });

      setHashtags(tempOption);
      setDefaultHastags(tempOption);
    }
  }, [hashtagOptions]);

  const getCoeNames = async (e, callback) => {
    if (e.length > 3) {
      let requestParams = {
        dropdownName: "getAllUsers",
        searchText: e,
      };
      const res = await APICall(getCommonDropdownData, requestParams, "POST");
      if (res && res.data.length > 0) {
        let options = await res.data;
        // options = await options.map((ele) => ({
        //   label: ele.UserName,
        //   value: ele.UserId,
        //   EmailId: ele.EmailId,
        // }));

        await callback(options);
      }
    }
  };

  const getUserNames = async (e, callback) => {
    if (e.length > 3) {
      let requestParams = {
        dropdownName: "getAllUsers",
        searchText: e,
      };
      const res = await APICall(getCommonDropdownData, requestParams, "POST");
      if (res && res.data.length > 0) {
        let options = await res.data;
        // options = await options.map((ele) => ({
        //   label: ele.UserName,
        //   value: ele.UserId,
        //   EmailId: ele.EmailId,
        // }));

        await callback(options);
      }
    }
  };

  const onFDPDCheck = (event) => {
    // setUserArray([]);
    // setSelectedCoeHideList([]);
    setGlobalFDPD(event);
    // setIsGlobalFDPD(event);
    if (!event) {
      setGlobalFDPDClass("row rowMargin");
    } else {
      setGlobalFDPDClass("row rowMargin disabledDiv");
    }
  };

  const getHashTags = async (event, cb) => {
    if (event.length >= 3) {
      let requestParams = {
        searchText: event,
      };
      const resp = await APICall(
        getHashtagsAutoComplete,
        requestParams,
        "POST",
      );
      if (resp.data.length > 0) {
        cb(resp.data);
      } else {
        cb([]);
      }
    }
  };

  const closeHistoryModal = (confirmation) => {
    setShowHistoryModal(false);
  };

  const closeActionModal = async (data) => {
    if (data === "submit") {
      if (action === "approve") {
        if (
          keywords === "" ||
          keywords === null ||
          knowledgeBaseId === null ||
          verificationStatus === ""
        ) {
          notify(1, "Please fill required field");
        } else {
          //call api
          const params = {
            id: requestDetailData.id,
            status: 5,
            keywords,
            knowledgeBaseId: knowledgeBaseId ? knowledgeBaseId.value : null,
            verificationStatus: verificationStatus === "verified" ? 8 : 9,
            userId: getFromEncLocalStorage("userId"),
            knowledge_created_by_id: requestDetailData.created_by_id,
            createdDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
          };

          const response = await APICall(
            updateKnowledgeDataById,
            params,
            "POST",
          );
          if (response.data !== null && response.data.length > 0) {
            notify(0, "knowledge updated successfully!");
            history.goBack();
          } else {
            notify(1, "knowledge updation failed, try again!");
          }
        }
      } else {
        if (remark === "") {
          notify(1, "Please fill required field");
        } else {
          //call api
          const employeeNum = getFromEncLocalStorage("employeenumber");
          const firstName = getFromEncLocalStorage("firstname");
          const lastName = getFromEncLocalStorage("lastname");

          const params = {
            id: requestDetailData.id,
            remark,
            status: action === "sendback" ? 3 : 4,
            userId: getFromEncLocalStorage("userId"),
            knowledge_created_by_id: requestDetailData.created_by_id,
            createdDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
            loginUserName: `${firstName} ${lastName}`,
            loginEmployeeName: employeeNum,
          };

          const response = await APICall(
            updateKnowledgeDataById,
            params,
            "POST",
          );
          if (response.data !== null && response.data.length > 0) {
            let msg = "Knowledge updated successfully!";
            switch (action) {
              case "sendback":
                msg = "Knowledge sent back successfully!";
                break;
              case "reject":
                msg = "Knowledge rejected successfully!";
                break;
            }
            notify(0, msg);
            history.goBack();
          } else {
            notify(1, "knowledge updation failed, try again!");
          }
        }
      }
    } else {
      setRemark("");
      setKeywords("");
      setKnowledgeBaseId(null);
      setVerificationStatus("");
      setActionModal(false);
    }
  };

  const onSubmit = async () => {
    if (
      title === "" ||
      description === "" //||
      // fileName === "" ||
      // fileName === null ||
      // attachment === null
    ) {
      notify(1, "Please fill required fields");
    } else if (
      !globalFDPD &&
      restrictedUsers.length === 0 &&
      restrictedCoe.length === 0
    ) {
      notify(1, "Please select the COE or Users who can see");
    } else {
      let newHashtagArray = [];
      //check if hashtags are present...if not then add them to master
      if (hashtags?.length > 0) {
        let elementsWithoutId = hashtags.filter(
          (hashtag) => typeof hashtag.value !== "number",
        );
        let elementsWithId = hashtags.filter(
          (hashtag) => typeof hashtag.value === "number",
        );

        elementsWithoutId = elementsWithoutId.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.value === value.value),
        );
        //Insert hashtags without ids in master
        if (elementsWithoutId.length > 0) {
          let requestParams = {
            hashtagArray: elementsWithoutId,
            userId: getFromEncLocalStorage("userId"),
            createdDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
          };
          const resp = await APICall(
            insertNewGeneratedHashtagsInMaster,
            requestParams,
            "POST",
          );

          console.log("resp: ", resp);
          if (resp) {
            if (
              resp.message &&
              resp.message.toLowerCase().includes("duplicate")
            ) {
              notify(1, resp.message);
              return;
            }
            newHashtagArray = [...resp.data, ...elementsWithId];
          }
        } else {
          newHashtagArray = [...elementsWithId];
        }
      }

      const params = {
        id: requestDetailData.id,
        title,
        description,
        status: isAdmin === "false" ? 2 : 0,
        attachment,
        fileName,
        fileType,
        // tagUsers:
        //   (tagUsers.length > 0 && tagUsers.map((ele) => ele.value).join(",")) ||
        //   null,
        restrictedUsers:
          (restrictedUsers.length > 0 &&
            restrictedUsers.map((ele) => ele.value).join(",")) ||
          null,
        restrictedCOE:
          (restrictedCoe.length > 0 &&
            restrictedCoe.map((ele) => ele.value).join(",")) ||
          null,
        tagUsers:
          (tagUsers.length > 0 && tagUsers.map((ele) => ele.value).join(",")) ||
          null,
        hashtags:
          (newHashtagArray.length > 0 &&
            newHashtagArray.map((ele) => ele.value).join(",")) ||
          null,
        currentLocation,
        userId: getFromEncLocalStorage("userId"),
        creatorName: requestDetailData.creator,
        createdDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
      };

      const response = await APICall(updateKnowledgeDataById, params, "POST");
      if (response.data !== null && response.data.length > 0) {
        notify(0, "Knowledge submitted successfully!");
        history.goBack();
      } else {
        notify(1, "knowledge updation failed, try again!");
      }
    }
  };

  const fileSelect = (e) => {
    if (e.target.files.length > 0) {
      let { type } = e.target.files[0];
      let strarray = type.split("/");
      let strng = strarray[0];

      let fileValidations = FileExtensionAllowed(
        e.target.files[0],
        allowedExtensions,
      );
      console.log(`error Text`, fileValidations);

      if (fileValidations != "") {
        toast(fileValidations);
      } else {
        setFilename(e.target.files[0].name);
        if (strng === "video") {
          uploadVideoTrans(e.target.files[0]);
          setFileType(type);
        } else if (strng === "audio") {
          uploadVideoTrans(e.target.files[0]);
          uploadFile(e.target.files[0], true, type);
          // setAttachment(e.target.files[0]);
        } else {
          uploadFile(e.target.files[0], false, type);
          // setAttachment(e.target.files[0]);
        }
      }
    }
  };

  const uploadFile = async (files, isAudio, type) => {
    let fileData = new FormData();
    fileData.append("file", files);

    let container = isAudio ? "audios" : "knowledge";
    setLoading(true);
    let resp = await CreateKnowledgeService.fileUpload(fileData, container);
    if (resp.status.toLowerCase() == "success") {
      setAttachment(resp.result[0]);
      setFileType(type);
      // setSubmit(false);
    } else if (resp.status.toLowerCase() == "error") {
      setFilename("");
      if (resp.message.toLowerCase() == "invalid file format") {
        notify(1, "Invalid File format");
      } else {
        notify(1, "Please try again");
      }
    }
    setLoading(false);
  };

  //video transcription
  const uploadVideoTrans = async (newFile) => {
    setLoading(true);
    const knowledgeData = new FormData();
    knowledgeData.append("", newFile);
    // console.log(newFile.name);
    let resp = await CreateKnowledgeService.uploadVideo(
      firstToken,
      knowledgeData,
      newFile.name,
    );
    if (resp) {
      let { id } = resp;
      // setVideoId(id);
      getDetails(firstToken, id);
    } else {
      setFilename("");
      notify(1, "Please try again");
    }
    setLoading(false);
  };

  const getDetails = async (firstToken, id) => {
    setProgress(true);
    let resp = await CreateKnowledgeService.getVideoDetails(firstToken, id);

    if (resp.results[0].processingProgress != "100%") {
      setTimeout(() => (resp = getDetails(firstToken, id)), 3000);
      let status = parseInt(resp.results[0].processingProgress);
      setProgStatus(status);
    } else {
      setThumbnailId(resp.results[0].thumbnailId);
      getVideoToken(id);
    }
  };

  const getVideoToken = async (id) => {
    let res = await CreateKnowledgeService.getVideoToken(id);
    if (res) {
      getTranscriptionData(id, res);
    }
  };

  const getTranscriptionData = async (id, tok) => {
    let res = await CreateKnowledgeService.getTranscription(id, tok);
    if (res) {
      let data = {
        transcript: res.videos[0].insights.transcript,
      };
      let transcript = JSON.stringify(data);
      setTranscriptionData(transcript);
    }
    setProgress(false);
  };

  //token

  const getToken = async () => {
    const res = await CreateKnowledgeService.firstApi();
    if (res) {
      setToken(res);
    }
  };

  useEffect(() => {
    getToken();
  }, []);

  useEffect(() => {
    if (isAdmin !== "false" && mode === "edit") {
      (async () => {
        let requestParams = {
          dropdownName: "knowledgeBaseDropdown",
        };
        const res = await APICall(getCommonDropdownData, requestParams, "POST");
        if (
          res?.data !== null ||
          (res?.data !== undefined && res?.data?.length > 0)
        ) {
          setKnowledgeBaseOptions(res.data);
        }
      })();
    }
  }, [mode]);

  useEffect(() => {
    if (
      knowledgeBaseOptions.length > 0 &&
      requestDetailData.KnowledgebaseId !== null
    ) {
      let selectedKnowledgeBase = knowledgeBaseOptions.find(
        (ele) => ele.value == requestDetailData.KnowledgebaseId,
      );

      setKnowledgeBaseId(selectedKnowledgeBase);
    }
  }, [knowledgeBaseOptions]);

  return (
    <>
      <Main active={"request"} removeContainer={true}>
        <Loadspinner
          filename="DashboardEdit.js"
          isLoading={loading}
          isMiddle="false"
        />
        <div className="eventGallery">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-4">
                <h4 style={{ paddingLeft: "15px" }}>
                  {isAdmin === "false" ? "Request" : "Approval"} Dashboard
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div
          className="d-flex p-3 justify-space-between align-items-center"
          style={{
            background: "var(--theme-red)",
            paddingTop: "10px",
            paddingBottom: "10px",
            color: "white",
          }}
        >
          <div>
            {requestDetailData.id !== null &&
            requestDetailData.id !== undefined ? (
              <>
                <span>Knowledge Id</span>
                <span
                  style={{
                    backgroundColor: "pink",
                    color: "black",
                  }}
                  className="p-2 m-2 rounded"
                >{`${requestDetailData.id}`}</span>
              </>
            ) : (
              <>
                <span>Knowledge Id</span>
                <span
                  style={{
                    backgroundColor: "pink",
                    color: "black",
                  }}
                  className="p-2 m-2 rounded"
                >
                  NA
                </span>
              </>
            )}
          </div>
          <div>
            <span>Status</span>
            <span
              style={{
                backgroundColor: "pink",
                color: "black",
              }}
              className="p-2 m-2 rounded"
            >{`${requestDetailData.status}`}</span>
          </div>
          <div>
            <span className="m-3">View History</span>
            <Tooltip title="history">
              <span
                className="btn-link"
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={() => setShowHistoryModal(true)}
              >
                <i className="fa fa-history"></i>
              </span>
            </Tooltip>
          </div>
        </div>
        <div className="container m-3">
          <div className="row card-row">
            <div className="col-12">
              <div className="form-group">
                <FormLabel value="Title"></FormLabel>
                <sup>*</sup>
                <InputForm
                  className="form-control"
                  placeholder={"Title"}
                  isDisabled={
                    isAdmin === "false" && mode === "edit" ? false : true
                  }
                  textArea={false}
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row card-row">
            <div className="col-12">
              <div className="form-group">
                <FormLabel value="Detailed Description"></FormLabel>
                <sup>*</sup>
                <InputForm
                  className="form-control"
                  placeholder={"Detailed Description"}
                  isDisabled={
                    isAdmin === "false" && mode === "edit" ? false : true
                  }
                  textArea={true}
                  value={description}
                  rows={5}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row card-row">
            <div className="form-group">
              <FormLabel value="Upload File"></FormLabel>
              <div className="col-12">
                <div
                  className="drop-container"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    margin: 0,
                    height: "60px",
                    border: "2px dashed #ced4da",
                  }}
                >
                  <div className="col-3">
                    <img
                      src={images.upload}
                      className="img-responsive"
                      width="30px"
                    />
                  </div>
                  <div className="col-6 message">
                    Attach Files(Documents ,Images, Audios & Video files)
                  </div>
                  <div className="col-3">
                    <input
                      type="file"
                      id="actual-btnn"
                      hidden
                      disabled={
                        isAdmin === "false" && mode === "edit" ? false : true
                      }
                      onChange={(e) => fileSelect(e)}
                      autoComplete={CommonConstants.autoCompleteInput}
                    />
                    <label style={{ width: "100%" }} htmlFor="actual-btnn">
                      <a
                        variant="contained"
                        component="span"
                        style={{
                          width: "100%",
                          textDecoration: "underline",
                          // backgroundColor: "#198754",
                          color: "red",
                        }}
                        disabled={loading}
                      >
                        Choose File
                      </a>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {fileName && (
            <div className="row card-row">
              <div className="col-12 ">
                {viewVideoId ? (
                  <div className="d-flex">
                    <a
                      target="blank"
                      className="btn-link text-truncate"
                      onClick={() => setShowVideoModal(true)}
                    >
                      <i className="fa fa-file"></i> {fileName}
                    </a>
                    {fileConversionStatus?.video_conversion_status && (
                      <div className="px-3">
                        <Typography variant="body1">
                          Conversion status :{" "}
                          <b>{fileConversionStatus?.video_conversion_status}</b>
                          , Progress :{" "}
                          <b>
                            {fileConversionStatus?.progress_int ||
                              parseInt(fileConversionStatus?.progress)}
                            %
                          </b>
                        </Typography>
                      </div>
                    )}
                  </div>
                ) : (
                  <a
                    target="blank"
                    className="btn-link text-truncate"
                    href={attachment}
                  >
                    <i className="fa fa-file"></i> {fileName}
                  </a>
                )}
              </div>
            </div>
          )}
          <div className="row card-row">
            <Paper variant="outlined my-3 mx-2">
              <div className="row rowMargin">
                <div className="col">
                  <div className="form-group">
                    {/* <Typography variant="h6">
                          Who can see the post?
                        </Typography> */}

                    {/* <label className="form-check-label">
                      Who can see the post?
                    </label> */}

                    <FormLabel value="Who can see the post?"></FormLabel>
                    <div className="custom-checkbox">
                      <input
                        disabled={
                          isAdmin === "false" && mode === "edit" ? false : true
                        }
                        type="checkbox"
                        onChange={(e) => onFDPDCheck(e.target.checked)}
                        name="isActive"
                        checked={globalFDPD}
                        className="isActive mx-2"
                        autoComplete={CommonConstants.autoCompleteInput}
                      />
                      <label className="col-form-label">Global FDPD</label>
                    </div>
                  </div>
                </div>
              </div>
              <Collapse in={!globalFDPD} timeout="auto" unmountOnExit>
                <div className={globalFDPDClass}>
                  <div className="col-6">
                    <label className="col-form-label">Restricted COE</label>

                    <SelectForm
                      options={(e, callback) => getUserNames(e, callback)}
                      placeholder="No COE Selected"
                      isDisabled={
                        isAdmin === "false" && mode === "edit" ? false : true
                      }
                      value={restrictedCoe}
                      onChange={(e) => setRestrictedCoe(e)}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                      menuPlacement="top"
                      menuPosition="fixed"
                      async
                      isSearchable
                    />
                  </div>
                  <div className="col-6 ">
                    <div className="form-group">
                      <label className="col-form-label">Restricted Users</label>

                      <SelectForm
                        options={(e, callback) => getUserNames(e, callback)}
                        placeholder="No Users Selected"
                        isDisabled={
                          isAdmin === "false" && mode === "edit" ? false : true
                        }
                        value={restrictedUsers}
                        onChange={(e) => setRestrictedUsers(e)}
                        isMulti={true}
                        noIndicator={false}
                        noSeparator={false}
                        menuPlacement="top"
                        menuPosition="fixed"
                        async
                        isSearchable
                      />

                      {/* {usersArray?.map((users) => {
                        return (
                          <li className="hashtagBg2">
                            {users.label}
                            <span
                              className="closeSpan"
                              onClick={(e) =>
                                removeUser(usersArray, users.value)
                              }
                            >
                              &#10060;
                            </span>
                          </li>
                        );
                      })} */}
                    </div>
                  </div>
                </div>
              </Collapse>
            </Paper>
          </div>
          <div className="row card-row">
            {/* <div className="col-6">
              <div className="form-group">
                <FormLabel value="Restrict Users" />

                <SelectForm
                  async
                  isSearchable
                  options={(e, callback) => getUserNames(e, callback)}
                  placeholder="No users selected"
                  isDisabled={
                    isAdmin === "false" && mode === "edit" ? false : true
                  }
                  value={restrictedUsers}
                  onChange={(event) => setRestrictedUsers(event)}
                  isMulti={true}
                  noIndicator={false}
                  noSeparator={false}
                />
              </div>
            </div> */}
            <div className="col-6">
              <div className="form-group">
                <FormLabel value="Hashtags" />
                <SelectFormCreatableV2
                  async
                  options={(e, callback) => getHashTags(e, callback)}
                  placeholder="No hashtags selected"
                  // defaultOptions={defaultHastags}
                  isDisabled={
                    isAdmin === "false" && mode === "edit" ? false : true
                  }
                  getOptionLabel={(option) => `#${option.label}`}
                  value={hashtags}
                  onChange={(e) => setHashtags(e)}
                  isMulti={true}
                  noIndicator={false}
                  noSeparator={false}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group">
                <FormLabel value="Tag Users" />
                {/* <sup>*</sup> */}
                <SelectForm
                  async
                  isSearchable
                  options={(e, callback) => getUserNames(e, callback)}
                  placeholder="No users selected"
                  // defaultOptions={defaultTagUsers}
                  isDisabled={
                    isAdmin === "false" && mode === "edit" ? false : true
                  }
                  value={tagUsers}
                  onChange={(event) => setTagUsers(event)}
                  isMulti={true}
                  noIndicator={false}
                  noSeparator={false}
                />
              </div>
            </div>
          </div>
          <div className="row card-row">
            {/* <div className="col-6">
              <div className="form-group">
                <FormLabel value="Tag Users" />
                <SelectForm
                  async
                  isSearchable
                  options={(e, callback) => getUserNames(e, callback)}
                  placeholder="No users selected"
                  isDisabled={
                    isAdmin === "false" && mode === "edit" ? false : true
                  }
                  value={tagUsers}
                  onChange={(event) => setTagUsers(event)}
                  isMulti={true}
                  noIndicator={false}
                  noSeparator={false}
                />
              </div>
            </div>  */}
            <div className="col-6">
              <div className="form-group">
                <FormLabel value="Current Location"></FormLabel>
                {/* <sup>*</sup> */}
                <InputForm
                  className="form-control"
                  placeholder={""}
                  isDisabled={
                    isAdmin === "false" && mode === "edit" ? false : true
                  }
                  textArea={false}
                  value={currentLocation}
                  onChange={(e) => setCurrentLocation(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row mt-4 card-row justify-content-end">
            <div className="col-3">
              <button
                type="reset"
                className="btn btn-danger"
                disabled={loading}
                style={{ width: "100%" }}
                data-bs-dismiss="modal"
                onClick={() => history.goBack()}
              >
                Cancel
              </button>
            </div>
            {isAdmin === "true" && mode === "edit" && (
              <>
                <div className="col-3">
                  <button
                    className="btn btn-export"
                    style={{ width: "100%" }}
                    type="submit"
                    onClick={() => {
                      if (
                        fileConversionStatus &&
                        fileConversionStatus?.video_conversion_status &&
                        fileConversionStatus?.video_conversion_status !=
                          ConversionStatus.UPLOADED
                      ) {
                        notify(
                          1,
                          "Please wait for video conversion to complete",
                        );
                      } else {
                        setActionModal(true);
                        setAction("approve");
                      }
                    }}
                    disabled={
                      loading || (isAdmin !== "false" && mode !== "edit")
                        ? true
                        : false
                    }
                    data-bs-dismiss="modal"
                  >
                    Approve
                  </button>
                </div>
                <div className="col-3">
                  <button
                    className="btn btn-secondary"
                    style={{ width: "100%" }}
                    type="submit"
                    onClick={() => {
                      if (
                        fileConversionStatus &&
                        fileConversionStatus?.video_conversion_status &&
                        fileConversionStatus?.video_conversion_status !=
                          ConversionStatus.UPLOADED
                      ) {
                        notify(
                          1,
                          "Please wait for video conversion to complete",
                        );
                      } else {
                        setActionModal(true);
                        setAction("sendback");
                      }
                    }}
                    disabled={
                      loading || (isAdmin !== "false" && mode !== "edit")
                        ? true
                        : false
                    }
                    data-bs-dismiss="modal"
                  >
                    Sendback
                  </button>
                </div>
                <div className="col-3">
                  <button
                    className="btn btn-danger"
                    style={{ width: "100%" }}
                    type="submit"
                    onClick={() => {
                      if (
                        fileConversionStatus &&
                        fileConversionStatus?.video_conversion_status &&
                        fileConversionStatus?.video_conversion_status !=
                          ConversionStatus.UPLOADED
                      ) {
                        notify(
                          1,
                          "Please wait for video conversion to complete",
                        );
                      } else {
                        setActionModal(true);
                        setAction("reject");
                      }
                    }}
                    disabled={
                      loading || (isAdmin !== "false" && mode !== "edit")
                        ? true
                        : false
                    }
                    data-bs-dismiss="modal"
                  >
                    Reject
                  </button>
                </div>
              </>
            )}
            {isAdmin === "false" && mode === "edit" && (
              <div className="col-3">
                <button
                  className="btn btn-export"
                  style={{ width: "100%" }}
                  type="submit"
                  onClick={() => onSubmit()}
                  disabled={
                    loading || (isAdmin === "false" && mode === "edit")
                      ? false
                      : true
                  }
                  data-bs-dismiss="modal"
                >
                  Submit
                </button>
              </div>
            )}
          </div>
        </div>
      </Main>
      <>
        <Modal
          show={showHistoryModal}
          onHide={() => closeHistoryModal(false)}
          backdrop="static"
          keyboard={false}
          size="xl"
          centered
        >
          <div
            style={{
              background: "var(--theme-red)",
              padding: "10px",
              color: "white",
            }}
          >
            <div className="col-lg-12">History</div>
          </div>
          <ViewHistory id={requestDetailData.id} />
          <Modal.Footer>
            <button
              className="btn btn-dark"
              style={{ marginLeft: 5 }}
              onClick={() => closeHistoryModal(false)}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </>
      <>
        <Modal
          show={actionModal}
          onHide={() => closeActionModal(false)}
          backdrop="static"
          keyboard={false}
          size="lg"
          centered
        >
          <div className="container mb-3">
            {action === "approve" ? (
              <>
                <div className="row card-row">
                  <div className="col-12">
                    <div className="form-group">
                      <FormLabel value="Keywords"></FormLabel>
                      <sup>*</sup>
                      <InputForm
                        className="form-control"
                        placeholder={"Keywords"}
                        isDisabled={false}
                        textArea={false}
                        value={keywords}
                        onChange={(e) => setKeywords(e.target.value)}
                      />
                    </div>
                    <small className="form-text text-muted">
                      Seperate keywords using comma
                    </small>
                  </div>
                </div>
                <div className="row card-row">
                  <div className="col-12">
                    <div className="form-group">
                      <FormLabel value="Knowledge Base"></FormLabel>
                      <sup>*</sup>
                      <SelectForm
                        isSearchable
                        options={knowledgeBaseOptions}
                        placeholder="Knowledge Base"
                        isDisabled={false}
                        value={knowledgeBaseId}
                        onChange={(event) => setKnowledgeBaseId(event)}
                        isMulti={false}
                        noIndicator={false}
                        noSeparator={false}
                      />
                    </div>
                  </div>
                </div>
                <div className="row card-row">
                  <div className="col-12">
                    <div className="form-group">
                      <FormLabel value="Status"></FormLabel>
                      <sup>*</sup>
                      <div>
                        <Form.Check
                          inline
                          type="radio"
                          label="Verified"
                          name={"verificationStatus"}
                          disabled={false}
                          id={`verificationStatus-1`}
                          checked={
                            verificationStatus === "verified" ? true : false
                          }
                          onChange={(event) => {
                            if (event.target.id === "verificationStatus-1") {
                              setVerificationStatus("verified");
                            }
                          }}
                        />
                        <Form.Check
                          inline
                          type="radio"
                          label="Unverified"
                          name={"verificationStatus"}
                          disabled={false}
                          id={`verificationStatus-2`}
                          checked={
                            verificationStatus === "unverified" ? true : false
                          }
                          onChange={(event) => {
                            if (event.target.id === "verificationStatus-2") {
                              setVerificationStatus("unverified");
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="row card-row">
                <div className="col-12">
                  <div className="form-group">
                    <FormLabel value="Remark"></FormLabel>
                    <sup>*</sup>
                    <InputForm
                      className="form-control"
                      placeholder={"Remark"}
                      isDisabled={false}
                      textArea={true}
                      rows={5}
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          <Modal.Footer>
            <button
              className="btn btn-dark"
              style={{ marginLeft: 5 }}
              onClick={() => closeActionModal(false)}
            >
              Cancel
            </button>
            <button
              className="btn btn-danger"
              style={{ marginLeft: 5 }}
              onClick={() => closeActionModal("submit")}
            >
              Submit
            </button>
          </Modal.Footer>
        </Modal>
      </>
      <>
        {isAdmin == "true" && viewVideoId && viewVideoUrl && (
          <VideoModal
            show={showVideoModal}
            hide={() => {
              setShowVideoModal(false);
            }}
            videoId={viewVideoId}
            viewVideoUrl={viewVideoUrl}
            videoMetadata={viewVideoMetadata}
          />
        )}
      </>
    </>
  );
};

export default DashboardEdit;
